<po-page-default
  p-title="Modulo de Entrada NFs - Documentos - Executar em Lote"
  [p-actions]="pageActions">

  <po-loading-overlay *ngIf="saving" p-text="Aprovando..."></po-loading-overlay>

  <po-widget
    *ngFor="let nota of notas; let i = index"
    [p-title]="'NF ' + nota.numeroNf"
    [class.po-mt-2]="i > 0">

    <div class="po-row">
      <po-info class="po-md-6" p-label="Tomador" [p-value]="nota.tomadorCnpj + ' - ' + nota.tomadorNome" [p-orientation]="poInfoOrientation.Horizontal"></po-info>
      <po-info class="po-md-6" p-label="Emitente" [p-value]="(nota.emitenteCnpj ? nota.emitenteCnpj + ' - ' : '') + nota.emitenteNome" [p-orientation]="poInfoOrientation.Horizontal"></po-info>
    </div>

    <div class="po-row po-mt-1">
      <div class="po-md-2">
        <span class="po-font-text-small po-font-text-bold">Status</span><br>
        <po-tag [p-value]="nota.status" p-color="color-08"></po-tag>
      </div>
      <div class="po-md-10" *ngIf="nota.uploadStatus">
        <span class="upload-status" [class.upload-status--ok]="nota.uploadStatus === 'ok'"
              [class.upload-status--erro]="nota.uploadStatus === 'erro'"
              [class.upload-status--info]="nota.uploadStatus === 'enviando'">
          {{ nota.uploadMsg }}
        </span>
      </div>
    </div>

    <po-divider></po-divider>

    <!-- Linha 1: identificacao + processo + financeiro -->
    <div class="po-row">
      <po-input
        class="po-md-2"
        p-label="Número da NF"
        [ngModel]="nota.numeroNf"
        (p-change)="nota.numeroNf = $event"
        p-pattern="^[A-Za-z0-9]+$"
        p-error-pattern="Informe apenas letras e numeros."
        [p-maxlength]="20"
        [attr.name]="'nf_' + i">
      </po-input>

      <po-input
        class="po-md-3"
        p-label="Processo"
        [ngModel]="nota.processo"
        (p-change)="nota.processo = $event; resolveTipoProcesso(nota)"
        [p-maxlength]="30"
        [p-disabled]="(nota.semProcesso === 'sim') ? 'true' : 'false'"
        [attr.name]="'proc_' + i">
      </po-input>

      <po-radio-group
        class="po-md-2"
        p-label="Gera Financeiro"
        [ngModel]="nota.geraFinanceiro"
        (p-change)="onGeraFinanceiroChange(nota, $event)"
        [p-options]="geraFinanceiroOptions"
        [name]="'fin_' + i">
      </po-radio-group>

      <!-- TES:
             - NFSe: lista hardcoded filtrada por geraFinanceiro + tipoProcesso
             - CTe: lista completa de cteTesOpcoes; autoPickTesCte sugere a
               inicial (com base em geraFinanceiro+valorPedagio+desc), mas o
               operador pode trocar (regra atualizada 2026-05-27).
             - CTe Sem Processo DAAS (semProcesso=sim): TES fixa 403,
               select bloqueado.
             - Logistica (005003): select SEMPRE editavel, inclusive com
               pedagio. Ali a TES depende da FINALIDADE do frete, que so quem
               envia o CTe conhece - confirmado pela fiscal em 22/09/2026,
               chamado 00018371 - e nenhuma TES da Logistica e especifica de
               pedagio, entao a trava por pedagio nao faz sentido. -->
      <po-select
        class="po-md-3"
        p-label="TES"
        [ngModel]="nota.tipoOperacao"
        (p-change)="nota.tipo === 'CTe' ? onTipoOperacaoCteChange(nota, $event) : onTipoOperacaoNfseChange(nota, $event)"
        [p-options]="getTipoOperacaoOptions(nota)"
        
        [p-disabled]="(nota.filial.substring(0, 6) !== '005003'
                       && ((nota.tipo === 'CTe' && nota.tomadorDaas && nota.semProcesso === 'sim')
                           || (nota.tipo === 'CTe' && (nota.valorPedagio || 0) > 0))) ? 'true' : 'false'"
        [attr.name]="'tipo_' + i">
      </po-select>

      <po-datepicker
        class="po-md-2"
        p-label="Vencimento"
        p-placeholder="dd/mm/aaaa"
        p-format="dd/mm/yyyy"
        [(ngModel)]="nota.vencimento"
        [p-disabled]="nota.geraFinanceiro !== 'sim' ? 'true' : 'false'"
        [attr.name]="'venc_' + i">
      </po-datepicker>
    </div>

    <!-- Sem processo: linha propria porque nao e mais exclusivo de CTe.
         Aparece quando o backend liberou pelo privilegio SEMPROC (menu
         /notas-list, qualquer especie) ou quando e CTe de tomador DAAS
         (regra 2026-05-27, avaliada localmente pelo CNPJ). Chamado 00017826. -->
    <div class="po-row" *ngIf="nota.podeSemProcesso || nota.tomadorDaas">
      <po-radio-group
        class="po-md-3"
        p-label="Sem processo"
        [ngModel]="nota.semProcesso"
        (p-change)="onSemProcessoChange(nota, $event)"
        [p-options]="semProcessoOptions"
        [name]="'semproc_' + i">
      </po-radio-group>
    </div>

    <!-- Linha 2 - CTe: Produto Frete + Pedagio + SN + Pasta GED. CNAE
         nao se aplica em CTe (planilha REGRAS CTE controla TES/produto). -->
    <div class="po-row" *ngIf="nota.tipo === 'CTe'">
      <po-select
        class="po-md-5"
        p-label="Produto Frete"
        [ngModel]="nota.produto"
        (p-change)="onProdutoCteChange(nota, $event)"
        [p-options]="produtosCteOptions"
        [attr.name]="'prodcte_' + i">
      </po-select>

      <po-decimal
        class="po-md-2"
        p-label="Valor Pedágio"
        [(ngModel)]="nota.valorPedagio"
        [p-decimals-length]="2"
        [attr.name]="'ped_' + i">
      </po-decimal>

      <po-switch
        class="po-md-2"
        p-label="Simples Nacional"
        [ngModel]="nota.simplesNacional"
        (p-change)="onSimplesNacionalChange(nota, $event)"
        [attr.name]="'sn_' + i">
      </po-switch>

      <po-select
        class="po-md-3"
        p-label="Pasta GED"
        [ngModel]="nota.gedFolder"
        (p-change)="nota.gedFolder = $event"
        [p-options]="gedFolderOptions"
        [attr.name]="'gedcte_' + i">
      </po-select>
    </div>

    <!-- Linha 2 - NFSe: CNAE + Pasta GED -->
    <div class="po-row" *ngIf="nota.tipo !== 'CTe'">
      <po-select
        class="po-md-8"
        p-label="Serviço (CNAE)"
        [ngModel]="nota.servicoCnae"
        (p-change)="nota.servicoCnae = $event"
        [p-options]="cnaeOptions"
        [p-disabled]="carregandoCnaes ? 'true' : 'false'"
        [attr.name]="'cnae_' + i">
      </po-select>

      <po-select
        class="po-md-4"
        p-label="Pasta GED"
        [ngModel]="nota.gedFolder"
        (p-change)="nota.gedFolder = $event"
        [p-options]="gedFolderOptions"
        [attr.name]="'ged_' + i">
      </po-select>
    </div>

    <!-- Anexos: 3 slots tipados (DAN/BOL/ROM) com drag-and-drop, mesmo
         padrao de notas-adicionar. Cada slot aceita 1 arquivo PDF max 10MB. -->
    <div class="anexos">
      <div class="anexo-slot"
           [class.anexo-slot--drag]="nota.danfeDragOver"
           (dragover)="onSlotDragOver($event, nota, 'danfe')"
           (dragleave)="onSlotDragLeave($event, nota, 'danfe')"
           (drop)="onSlotDrop($event, nota, 'danfe')">
        <span class="anexo-slot__label">DANFE (PDF)</span>
        <label class="anexo-slot__btn">
          <span class="po-icon an an-paperclip"></span>
          <span class="anexo-slot__btn-text">
            {{ nota.danfeFile ? nota.danfeFile.name : 'Selecionar ou arraste aqui' }}
          </span>
          <input
            type="file"
            accept=".pdf,application/pdf"
            (change)="onFileSelected($event, nota, 'danfe')"
            hidden>
        </label>
        <a *ngIf="nota.danfeFile" class="anexo-slot__clear" (click)="clearFile(nota, 'danfe')">Remover</a>
      </div>

      <div class="anexo-slot"
           [class.anexo-slot--drag]="nota.boletoDragOver"
           [class.anexo-slot--disabled]="nota.geraFinanceiro !== 'sim'"
           (dragover)="nota.geraFinanceiro === 'sim' && onSlotDragOver($event, nota, 'boleto')"
           (dragleave)="onSlotDragLeave($event, nota, 'boleto')"
           (drop)="nota.geraFinanceiro === 'sim' && onSlotDrop($event, nota, 'boleto')">
        <span class="anexo-slot__label">Boleto (PDF)</span>
        <label class="anexo-slot__btn">
          <span class="po-icon an an-paperclip"></span>
          <span class="anexo-slot__btn-text">
            {{ nota.geraFinanceiro !== 'sim'
                 ? 'Disponivel apenas com Gera Financeiro = Sim'
                 : (nota.boletoFile ? nota.boletoFile.name : 'Selecionar ou arraste aqui') }}
          </span>
          <input
            type="file"
            accept=".pdf,application/pdf"
            (change)="onFileSelected($event, nota, 'boleto')"
            [disabled]="nota.geraFinanceiro !== 'sim'"
            hidden>
        </label>
        <a *ngIf="nota.boletoFile && nota.geraFinanceiro === 'sim'" class="anexo-slot__clear" (click)="clearFile(nota, 'boleto')">Remover</a>
      </div>

      <div class="anexo-slot"
           [class.anexo-slot--drag]="nota.romaneioDragOver"
           (dragover)="onSlotDragOver($event, nota, 'romaneio')"
           (dragleave)="onSlotDragLeave($event, nota, 'romaneio')"
           (drop)="onSlotDrop($event, nota, 'romaneio')">
        <span class="anexo-slot__label">Romaneio (PDF)</span>
        <label class="anexo-slot__btn">
          <span class="po-icon an an-paperclip"></span>
          <span class="anexo-slot__btn-text">
            {{ nota.romaneioFile ? nota.romaneioFile.name : 'Selecionar ou arraste aqui' }}
          </span>
          <input
            type="file"
            accept=".pdf,application/pdf"
            (change)="onFileSelected($event, nota, 'romaneio')"
            hidden>
        </label>
        <a *ngIf="nota.romaneioFile" class="anexo-slot__clear" (click)="clearFile(nota, 'romaneio')">Remover</a>
      </div>
    </div>

  </po-widget>

</po-page-default>
